import React from "react";

export default function Compliance() {
	return (
		<>
			<div className="beratung_cont" id="compliance_management">
				<h1>Passgenaue Beratung durch die Feingeist Compliance Services</h1>
				<p>
					<em>„If you think compliance is expensive, try non-compliance!“</em>
				</p>
				<p>
					Die Einhaltung interner und stark zunehmender externer Vorgaben führt
					zu einer erhöhten Komplexität für die Unternehmen und damit für deren
					Compliance-Management-Systeme. Als Konsequenz daraus steigen die
					Anforderungen an die Compliance-Funktion und das
					Compliance-Management-System in Unternehmen zur Vermeidung,
					Früherkennung und Aufklärung von Compliance-Verstößen. Im
					Zusammenspiel mit den begrenzten personellen Kapazitäten können
					Unternehmen durch effiziente Prozesse, punktgenaue externe Expertise
					oder (teil-) Auslagerungen den gestiegenen Herausforderungen begegnen.
				</p>
				<h2>
					Ihre Vorteile bei der Zusammenarbeit mit Feingeist Compliance
					Services:
				</h2>
				<ul className="typeset-u-list">
					<li>
						Leitung aller Projekte durch erfahrene zertifizierte Compliance
						Officer
					</li>
					<li>
						Umfassende Erfahrung im Design und Aufbau angemessener
						Compliance-Management-systeme
					</li>
					<li>
						Neben den „typischen Compliance-Risiken“ Berücksichtigung neuer
						Entwicklungen wie z.B. ESG-Risiken
					</li>
					<li>
						Abrundung durch aussagekräftige Reportings und Handlungsempfehlungen
						(z.B. zur Minimierung der Risiken)
					</li>
					<li>Partner für dauerhafte Auslagerungen im Bereich Compliance</li>
				</ul>
				<p>Sprechen Sie uns an.</p>
			</div>
		</>
	);
}
